import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { animateToScreen } from '../../redux/ui/actions';
import { setTicketPassengers as setTicketPassengersAction } from '../../redux/cardReader/actions';
import backgroundImg from '../../assets/screens/screen-add-passengers.png';
import backgroundImgMinusPlus from '../../assets/screens/screen-add-passengers-minus-plus.png';
import backgroundImgMax from '../../assets/screens/screen-add-passengers-max.png';
import CardReaderScreen from '../../molecules/CardReaderScreen';
import PassengersScreenContent from '../../molecules/PassengersScreenContent';
import {
  MAX_PASSENGERS_COUNT,
  TICKET_TYPE_EXTRA_TICKET,
} from '../../constants';

class ExtraTicketPassengersRC extends PureComponent {
  // eslint-disable-next-line
  state = {
    passengers: this.props.passengers, // this.props.passengers === 1 ? 2 : this.props.passengers,
  };

  onMinusButtonClick = () => {
    const currentPassengers = this.state.passengers;
    const newPassengers = currentPassengers - 1;
    this.setState({
      passengers: newPassengers < 1 ? 1 : newPassengers,
    });
  };

  onPlusButtonClick = () => {
    const currentPassengers = this.state.passengers;
    const newPassengers = currentPassengers + 1;
    this.setState({
      passengers:
        newPassengers > MAX_PASSENGERS_COUNT
          ? currentPassengers
          : newPassengers,
    });
  };

  onContinueButtonClick = () => {
    this.props.setTicketPassengers(this.state.passengers);
    this.props.goBack();
  };

  selectImage = () => {
    if (this.state.passengers < 2) {
      return backgroundImg;
    }

    if (this.state.passengers > 62) {
      return backgroundImgMax;
    }

    return backgroundImgMinusPlus;
  };

  render() {
    const { passengers } = this.state;
    const { currentZone, zones, goBack } = this.props;
    return (
      <CardReaderScreen
        backgroundImage={this.selectImage()}
        fadeDuration="500ms"
      >
        <PassengersScreenContent
          currentZone={currentZone}
          ticketZones={zones}
          ticketPassengers={passengers}
          onBackButtonClick={goBack}
          onMinusButtonClick={this.onMinusButtonClick}
          onPlusButtonClick={this.onPlusButtonClick}
          onContinueButtonClick={this.onContinueButtonClick}
        />
      </CardReaderScreen>
    );
  }
}

ExtraTicketPassengersRC.propTypes = {
  goBack: PropTypes.func.isRequired,
  setTicketPassengers: PropTypes.func.isRequired,
  currentZone: PropTypes.string.isRequired,
  zones: PropTypes.string.isRequired,
  passengers: PropTypes.number.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
  zones: cardReader.extraTicket.zones,
  passengers: cardReader.extraTicket.passengers,
});

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(animateToScreen('ExtraTicketPurchase')),
  setTicketPassengers: (passengers) => dispatch(setTicketPassengersAction(TICKET_TYPE_EXTRA_TICKET, passengers)), // eslint-disable-line
});

// prettier-ignore
export default connect(mapStateToProps, mapDispatchToProps)(ExtraTicketPassengersRC);
